const doc = [({"da":({"js":({"routes":({"admin":({"courses":({"edit":({"the_course_was_saved":"Forløbet blev gemt."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;